import { z } from 'zod';

export const SendFormSchema = z.object({
  emails: z
    .array(
      z.object({
        email: z
          .string({
            required_error: 'email.error.empty',
          })
          .email('invalidEmail'),
      }),
    )
    .refine(
      (items) => {
        const setItems = new Set<string>();
        items.map((item) => {
          setItems.add(item.email);
        });
        return setItems.size === items.length;
      },
      {
        message: 'email.error.duplicate',
      },
    ),
  emailOrdersBoolean: z.boolean(),
  emailOrders: z.string().email('invalidEmail'),
  emailInvoiceBoolean: z.boolean(),
  emailInvoice: z.string().email('invalidEmail'),
  emailTimesheetBoolean: z.boolean(),
  emailTimesheet: z.string().email('invalidEmail'),
  customerName: z
    .string({
      required_error: 'fieldRequired',
    })
    .min(1, 'fieldRequired'),
});
